import { useCallback } from 'react'

import { ensureError } from '@orus.eu/error'
import { useCrash } from '@orus.eu/pharaoh'

/**
 * Like useCallback, but takes a function that returns a promise, and handles error management
 *
 * A TechnicalError is thrown if the asyncCallback
 *
 * @param callback
 */
export function useAsyncCallback<ARGS extends unknown[]>(
  callback: (...args: ARGS) => Promise<void>,
): (...args: ARGS) => void {
  const crash = useCrash()

  return useCallback(
    (...args: ARGS) => {
      callback(...args).catch((err: unknown) => {
        crash(ensureError(err))
      })
    },
    [callback, crash],
  )
}
